import GridBox from "./dt-grid-box";
import GridSeparator from "./dt-grid-separator";
import GridTab from "./dt-grid-tab";
import GridLayout, { GridColumn, GridRow } from "./dt-grid-layout";
import { TabPanel } from '../sidewindow/tab-panel';


export const NTOffsets = {
  default: 2,
  WithHeader: 34,
  WithHeaderFooter: 0,
  WithHeaderDBoxBottom: 82,
  WithHeaderFooterDBoxBottom: 0,
  WithDBoxBottom: 50,
}

/**
 * @returns {Vue.Component} vue
 */
export const createDTGridHost = ({
  sidewindowKey = 'productSidewindowTabs'
} = {}) => {
  return {
    components: {
      GridTab,
      GridBox,
      GridLayout,

      gcol: GridColumn,
      grow: GridRow,

      gtab: GridTab,
      gbox: GridBox,
      glayout: GridLayout,
      TabPanel,
    },


    data() {
      return {
        NTOffsets,
      }
    },

    // watch: {
    //   '$route': {
    //     immediate: true,
    //     handler(to, from) {
    //       // console.log('$route watch to', to?.name, from?.name);
    //       if (!from || to?.params?.tab === from?.params?.tab) {
    //         return;
    //       }
    //       console.log('$route watch', this.$refs.gridlayout);
    //       console.log('$route watch', this.$el);
    //       // this.$nextTick(() => {
    //       //   this.$refs.gridlayout && this.$refs.gridlayout.reset();
    //       // });
    //     },
    //   },
    // },

    methods: {
      tabSelected() { },
      boxHeight(rowCount = 0, offset = NTOffsets.WithHeaderDBoxBottom, rowHeight = 32, max = 15, min = 0) {
        const adjustedRowCount = rowCount > max ? max : rowCount < min ? min : rowCount;
        return 32 + offset + (rowHeight * adjustedRowCount);
      },
      boxHeightNamed({ rowCount = 0, offset = NTOffsets.WithHeaderDBoxBottom, rowHeight = 32, max = 15, min = 0 } = {}) {
        const adjustedRowCount = rowCount > max ? max : rowCount < min ? min : rowCount;
        return 32 + offset + (rowHeight * adjustedRowCount);
      },
      groupedRowCount(array) {
        return array.reduce((accm, cur) => accm + (cur.group_title ? 2 : 1), 0);
      }
    }
  }
}


